import React from 'react'
import { connect } from 'react-redux'
import InfoPanel from '../../components/InfoPanel'
import * as actions from '../../store/actions'
import RoznicaCITRZiSStyle from '../../styles/RoznicaCITRZiSStyle'
import { czyKwotyWTysiacach } from '../../lib/structureChecker'

import InformacjaDodatkowaPodatekDochodowy from '../../components/roznicaCITRZis/InformacjaDodatkowaPodatekDochodowy'
import InformacjaDodatkowaPodatekDochodowyOpcjonalna from '../../components/roznicaCITRZis/InformacjaDodatkowaPodatekDochodowyOpcjonalna'
import zaokragl from '../../lib/mathUtils'

class RoznicaCITRZiS extends React.Component {
  aktualizujSumy = (value, index, name) => {
    if (!value) value = 0
    const getValue = (stateIndex, value, eventIndex, name) => {
      if (stateIndex === eventIndex) return value
      return this.props.section.Dane.Pozycje[stateIndex][name]
    }

    this.props.onSetSectionDataArray(value, index, name)
    if (name === 'KwotaRP' || name === 'KwotaRB') {
      const kwota =
        getValue(0, value, index, name) -
        getValue(1, value, index, name) -
        getValue(2, value, index, name) +
        getValue(3, value, index, name) +
        getValue(4, value, index, name) +
        getValue(5, value, index, name) -
        getValue(6, value, index, name) -
        getValue(7, value, index, name) +
        getValue(8, value, index, name)
      this.props.onSetSectionDataArray(zaokragl(kwota), 9, name)
    }
  }

  expandContent = (WersjaSchemy) => {
    return (
      <>
        <div>
          W poniższej tabeli należy rozliczyć różnicę pomiędzy podstawą
          opodatkowania podatkiem dochodowym a wynikiem finansowym
          <br />
          {(WersjaSchemy === '1-2') ? '(zyskiem, stratą) brutto. Wypełniają wyłącznie jednostki zobowiązane.' : '(zyskiem, stratą) brutto.'}
          <br />
          <br />
          Obowiązkowo należy podać kwoty łączne za rok bieżący. Opcjonalne jest:
        </div>
        <ul>
          <li>podanie kwot za rok poprzedni</li>
          <li>
            wyszczególnienie kwot przychodów / kosztów z zysków kapitałowych
          </li>
        </ul>
        <div>
          Ponadto, jeśli kwoty w pozycjach od B. do G. oraz I. są większe bądź
          równe 20 000zł, obowiązkowo należy podać podstawę prawną.
        </div>
      </>
    )
  }

  rolledContent = () => {
    return (
      <div>
        W poniższej tabeli należy rozliczyć różnicę pomiędzy podstawą
        opodatkowania podatkiem dochodowym a wynikiem finansowym
        <br />
        (zyskiem, stratą) brutto
      </div>
    )
  }

  render() {
    const { sectionList, onSetSectionData, czyKwotyWTysiacach, WersjaSchemy } = this.props
    return (
      <>
        <InfoPanel
          canExpand={true}
          exptandContent={this.expandContent(WersjaSchemy)}
          rolledContent={this.rolledContent()}
        />
        <RoznicaCITRZiSStyle>
          {sectionList.map((data, index) => {
            switch (data.TypSekcji) {
              case 'InformacjaDodatkowaPodatekDochodowy':
                return (
                  <InformacjaDodatkowaPodatekDochodowy
                    key={index}
                    data={data.Dane}
                    aktualizujSumy={this.aktualizujSumy}
                    czyKwotyWTysiacach={czyKwotyWTysiacach}
                    onSetSectionDataArray={this.props.onSetSectionDataArray}
                  />
                )
              case 'InformacjaDodatkowaPodatekDochodowyOpcjonalna':
                return (
                  <InformacjaDodatkowaPodatekDochodowyOpcjonalna
                    key={index}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    aktualizujSumy={this.aktualizujSumy}
                    czyKwotyWTysiacach={czyKwotyWTysiacach}
                    onSetSectionDataArray={this.props.onSetSectionDataArray}
                  />
                )
              default:
                return null
            }
          })}
        </RoznicaCITRZiSStyle>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
    WersjaSchemy: state.sprawozdanie.header.WersjaSchemy,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetSectionDataArray: (value, index, name) => {
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
    onSetSectionData: (e, index) => {
      let { name, checked } = e.target
      dispatch(actions.setSectionData(name, checked, index))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoznicaCITRZiS)
